import Vue from 'vue'
import component from './main.vue'

// export default component
const ActPop = Vue.extend(component)
const ActPopDiv = document.createElement('DIV')
ActPopDiv.id = 'actPop'
document.body.appendChild(ActPopDiv)
Vue.prototype.$pop = new ActPop().$mount('#actPop')